import script from "./PurchaseMainTypeSelector.vue?vue&type=script&lang=js"
export * from "./PurchaseMainTypeSelector.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__